module.exports = __webpack_public_path__ + "static/media/Avenir-MediumOblique.a40a5c25.woff2";